var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatCircleDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6786 22.1248C4.18768 19.6114 3.66554 16.6403 4.21024 13.7692C4.75494 10.8982 6.329 8.32469 8.63685 6.53206C10.9447 4.73944 13.8276 3.85096 16.7442 4.03347C19.6607 4.21598 22.4103 5.45693 24.4767 7.52328C26.5431 9.58963 27.784 12.3393 27.9666 15.2558C28.1491 18.1724 27.2606 21.0553 25.468 23.3631C23.6754 25.671 21.1019 27.2451 18.2309 27.7898C15.3598 28.3345 12.3887 27.8124 9.87532 26.3215L9.87534 26.3213L5.73077 27.5055C5.5593 27.5545 5.37784 27.5567 5.20521 27.512C5.03257 27.4673 4.87504 27.3772 4.74894 27.2511C4.62283 27.125 4.53275 26.9674 4.48802 26.7948C4.44328 26.6222 4.44553 26.4407 4.49452 26.2692L5.67869 22.1247L5.6786 22.1248Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.505C10.8284 17.505 11.5 16.8335 11.5 16.005C11.5 15.1766 10.8284 14.505 10 14.505C9.17157 14.505 8.5 15.1766 8.5 16.005C8.5 16.8335 9.17157 17.505 10 17.505Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.505C16.8284 17.505 17.5 16.8335 17.5 16.005C17.5 15.1766 16.8284 14.505 16 14.505C15.1716 14.505 14.5 15.1766 14.5 16.005C14.5 16.8335 15.1716 17.505 16 17.505Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.505C22.8284 17.505 23.5 16.8335 23.5 16.005C23.5 15.1766 22.8284 14.505 22 14.505C21.1716 14.505 20.5 15.1766 20.5 16.005C20.5 16.8335 21.1716 17.505 22 17.505Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircleDots);
export default __webpack_public_path__ + "static/media/ChatCircleDots.46b5ec071788e34b61bf264214c2bc8d.svg";
export { ForwardRef as ReactComponent };